/* global dashboard:true */

/**
 * Object: dashboard
 * Purpose:
 */
dashboard = function(id) {
	'use strict';

	var objDashboard = {};
	var objList = list();

	/* initialize growls */
	$('#growls').notify();

	// Set the ajax paramaters.
	var params = {
		page: '1'
	};

	var notificationParams = {
		page: '1'
	};


	/*
	 * Function: getNotifications
	 * Purpose:
	 */
	objDashboard.getNotifications = function(pageDirection,type) {
		notificationParams.page = parseInt(notificationParams.page, 10) + parseInt(pageDirection, 10);

		$.ajax({
			url: '/dashboardItem.ajax',
			type: 'GET',
			data: {display:'notifications',notificationType:type,notificationsPage:notificationParams.page},
			beforeSend: function() {
				objDashboard.addMask('curriculog-dashboard-recent-notifications');
			},
			complete: function() {
				objDashboard.removeMask('curriculog-dashboard-recent-notifications');
			},
			success: function(data) {
				var html = $(data).filter('#curriculog-dashboard-recent-notifications').contents();
				$('#curriculog-dashboard-recent-notifications').contents().remove();
				$('#curriculog-dashboard-recent-notifications').append(html);
			}
		});
	};


	/*
	 * Function: getUpcomingEvents
	 * Purpose:
	 */
	objDashboard.getUpcomingEvents = function(pageDirection, type) {
		params.page = parseInt(params.page, 10) + parseInt(pageDirection, 10);

		$.ajax({
			url: '/dashboardItem.ajax',
			type: 'GET',
			data: {display:'upcoming',upcomingType:type,upcomingPage:params.page},
			beforeSend: function() {
				objDashboard.addMask('curriculog-dashboard-upcoming-events');
			},
			complete: function() {
				objDashboard.removeMask('curriculog-dashboard-upcoming-events');
			},
			success: function(data) {
				var html = $(data).filter('#curriculog-dashboard-upcoming-events').contents();
				$('#curriculog-dashboard-upcoming-events').contents().remove();
				$('#curriculog-dashboard-upcoming-events').append(html);
			}
		});
	};


	/*
	 * Function: deleteProposal
	 * Purpose: I delete proposals.
	 * DEPRECATED. MOVED THIS TO PROPOSAL LIST
	 */
	// objDashboard.deleteProposal = function(proposalId, callback) {

	// 	var dialog = objDialog.createBasicWarningDialog('delete-proposal', function(dialog, defaults) {
	// 		var cancelled = false;
	// 		// Message
	// 		$(dialog).append('Deleting this Proposal will permanently remove it from Curriculog. Are you sure you want to delete this Proposal?');
	// 		// Actions
	// 		defaults.buttons = {
	// 			'Delete Proposal': function() {
	// 				$.ajax({
	// 					url: '/proposal:' + proposalId + '.json',
	// 					type: 'DELETE',
	// 					async:false,
	// 					success: function(result) {
	// 						console.log('DELETED Proposal ' + proposalId);
	// 						// callback && callback();
	// 					}
	// 				});

	// 				$(this).dialog('close');
	// 			},
	// 			Cancel: function() {
	// 				cancelled = true;
	// 				// $('#'+itemId).removeClass('curriculog-remove-warning-highlight');
	// 				$(this).dialog('close');
	// 			}
	// 		};
	// 		defaults.close = function() {
	// 			if (!cancelled) {
	// 				if (callback) {
	// 					callback();
	// 				}
	// 			}
	// 		};
	// 		$(dialog).dialog(defaults);
	// 	});
	// };




	/*
	 * Function: addMask
	 * Purpose: adds a saving mask to the element
	 */
	objDashboard.addMask = function(id) {
		$('#' + id).mask('Loading...Please Wait');
	};


	/*
	 * Function: removeMask
	 * Purpose: removes a saving mask from the element
	 */
	objDashboard.removeMask = function(id) {
		$('#' + id).unmask();
	};

	return objDashboard;

};